// Build + download a credential sheet for bulk-provisioned student logins.
// The generated passwords are returned by the Edge Function exactly once, so
// this export is the institute's only durable copy — offer it prominently.

export interface CredentialExportRow {
  name: string;
  username: string;
  password: string;
  loginUrl: string;
}

function csvEscape(value: string): string {
  // Quote when the value contains a delimiter, quote, or newline (RFC 4180).
  if (/[",\r\n]/.test(value)) return `"${value.replace(/"/g, '""')}"`;
  return value;
}

export function buildCredentialsCsv(rows: CredentialExportRow[]): string {
  const header = ['name', 'username', 'password', 'login_url'];
  const lines = [header.join(',')];
  for (const r of rows) {
    lines.push([r.name, r.username, r.password, r.loginUrl].map(csvEscape).join(','));
  }
  return lines.join('\r\n');
}

export function downloadCredentialsCsv(
  rows: CredentialExportRow[],
  filename = 'student-logins.csv',
): void {
  const csv = buildCredentialsCsv(rows);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
